import React, { useState, useEffect } from 'react';
import { getPWAInstallPrompt, clearPWAInstallPrompt } from '../../pwaInstall';

const DISMISS_KEY = 'reservo_pwa_dismiss_count';

export default function PWAInstallPrompt() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleInstallAvailable = () => {
      const dismissCount = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
      if (dismissCount < 3) {
        setShowBanner(true);
      }
    };

    window.addEventListener('pwaInstallAvailable', handleInstallAvailable);

    // Check if prompt is already available
    if (getPWAInstallPrompt()) handleInstallAvailable();

    return () => window.removeEventListener('pwaInstallAvailable', handleInstallAvailable);
  }, []);

  const handleInstall = async () => {
    const prompt = getPWAInstallPrompt();
    if (!prompt) return;

    prompt.prompt();
    const { outcome } = await prompt.userChoice;

    if (outcome === 'accepted') {
      clearPWAInstallPrompt();
      setShowBanner(false);
    }
  };

  const handleDismiss = () => {
    const count = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10) + 1;
    localStorage.setItem(DISMISS_KEY, String(count));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed flex items-center justify-between mx-auto" style={{
      bottom: 20, left: 20, right: 20, zIndex: 9000,
      background: '#0a1628', borderRadius: 20, padding: '16px 20px',
      boxShadow: '0 20px 50px rgba(0,0,0,0.3)', maxWidth: 480,
      animation: 'fadeUp 0.4s ease',
    }}>
      <div className="flex items-center" style={{ gap: 14 }}>
        <div style={{ fontSize: '1.5rem' }}>📱</div>
        <div>
          <div className="font-bold text-white" style={{ fontSize: '0.95rem' }}>Install Reservo</div>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.82rem' }}>Add to home screen for the best experience</div>
        </div>
      </div>
      <div className="flex" style={{ gap: 8 }}>
        <button onClick={handleDismiss} className="border-0 cursor-pointer" style={{
          padding: '8px 16px', borderRadius: 100, background: 'transparent',
          color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', fontWeight: 500,
        }}>Not now</button>
        <button onClick={handleInstall} className="border-0 cursor-pointer font-semibold" style={{
          padding: '8px 20px', borderRadius: 100,
          background: 'linear-gradient(135deg, #2dd4a8, #6ee7b7)',
          color: '#0a1628', fontSize: '0.85rem',
        }}>Install</button>
      </div>
    </div>
  );
}
